module.exports = __webpack_public_path__ + "img/TZS09634.a2b27bf0.jpeg";